/**
 * GLSL shader source strings for the wind heatmap WebGL renderer.
 *
 * SpecRef: ARCH-002
 * Reference: docs/decisions/ARCH-002-webgl-heatmap-migration.md
 *
 * Shaders live in separate .glsl files for editor syntax highlighting.
 * Imported as raw strings via Vite's ?raw suffix.
 *
 * WebGL 1 / GLSL ES 1.0 for maximum browser compatibility.
 */

import FRAGMENT_SHADER_RAW from './heatmap.frag.glsl?raw';
import VERTEX_SHADER_RAW from './heatmap.vert.glsl?raw';

export const VERTEX_SHADER_SOURCE: string = VERTEX_SHADER_RAW;
export const FRAGMENT_SHADER_SOURCE: string = FRAGMENT_SHADER_RAW;
